/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : appConstants.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
// Constant States
export const FORM_TYPES = { SWM: 100, EE: 200, VEHICLE: 300, VEHICLE_COMPONENT: 300, VEHICLE_SYSTEM: 400 };
export const TICKETS_TYPES = {
  SWM: 1,
  EE: 2,
  VEHICLE: 3,
  VEHICLE_COMPONENT: 3,
  VEHICLE_SYSTEM: 6,
};
export const ALIGN_TYPES = { LEFT: "left", CENTER: "center", RIGHT: "right" };
export const FIELD_TYPES = { NUMBER: "number", TEXT: "string" };
export const EDIT_TYPES = { DDH: 100, SNOW: 200, BOTH: 300 };
export const DYNAMICFORM_TEMPLATE_TAG = { old: "OLD", new: "NEW" };
export const CAPABILITY_CODE = {
  supplier: "EXTERNAL_SUPPLIER_USER",
};
export const otaModuleActionTypes = {
  NO_ACTION: 0,
  MODULE_LINKING: 1,
  LEGAL_LINKING: 2,
  ECU_CHANGES: 3,
};

export const defaultConstats = {
  recentDataPageSize: 15,
  recentDataPageNumber: 1,
  font: "Poppins, sans-serif",
  fontSize: "12px",
};
